module.exports = __webpack_public_path__ + "42d17f2d35a810acc32552a871dd5893.pdf";